@if (premium) {
  <mat-card
    appearance="outlined"
    class="premium-card position-relative hiding-div mb-3"
  >
    <div class="premium-card-header mb-3">
      <h6 class="premium-card-title mb-0 font-weight-bold">
        {{ 'policies.add-edit.per-person-premium' | translate }}
      </h6>
    </div>

    <div class="premium-breakdown-list">
      @for (cover of covers; track cover) {
        <div class="premium-line-item d-flex justify-content-between align-items-center py-1">
          <span class="item-name text-muted">{{ cover.name }}</span>
          <span class="item-value font-weight-medium">
            <span class="currency-label">{{ baseCurrency }}</span>
            {{ thousandSeparatorAdd(cover.value) }}
          </span>
        </div>
      }

      @if (fees_and_charges?.length > 0) {
        <mat-divider class="my-2"></mat-divider>

        @for (fee of fees_and_charges; track fee) {
          <div class="premium-line-item d-flex justify-content-between align-items-center py-1">
            <span class="item-name text-muted">{{ fee.name }}</span>
            <span class="item-value font-weight-medium">
              <span class="currency-label">{{ baseCurrency }}</span>
              {{ thousandSeparatorAdd(fee.value) }}
            </span>
          </div>
        }
      }
    </div>

    <!-- TOTAL PREMIUM BAR -->
    <div class="total-premium-bar mt-3 d-flex justify-content-between align-items-center px-3 py-2 rounded">
      <span class="total-label font-weight-bold">
        {{ 'shared.premium-displayer.total-premium' | translate }}
      </span>
      <span class="total-amount font-weight-bold">
        <span class="total-currency mr-1">{{ baseCurrency }}</span>
        {{ thousandSeparatorAdd(premium) }}
      </span>
    </div>
  </mat-card>
}
